import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import MainRoute from "./Routing/index";
import Loader from "./Components/Loader/Loader";
import UserRoutes from "./Components/UserPanel";
import AdminRoutes from "./Components/AdminPanel";

const AppRoutes = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <Loader fullscreen />; // show loader while checking user
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      {!user && <MainRoute />}

      {user && user?.is_admin && <AdminRoutes />}

      {user && !user?.is_admin && <UserRoutes />}
    </Router>
  );
};

export default AppRoutes;
